import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfter = ({ beforeSrc, afterSrc, beforeLabel, afterLabel, altBefore, altAfter }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos(Math.min(97, Math.max(3, ((clientX - rect.left) / rect.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      onPointerDown={(e) => {
        ref.current.setPointerCapture(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => {
        if (e.buttons === 1) update(e.clientX);
      }}
      className="relative w-full aspect-[3/4] max-h-[75vh] mx-auto overflow-hidden rounded-3xl cursor-ew-resize select-none touch-none shadow-2xl shadow-slate-900/25 bg-slate-200"
      role="slider"
      aria-valuenow={Math.round(pos)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`${beforeLabel} / ${afterLabel}`}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(3, p - 4));
        if (e.key === "ArrowRight") setPos((p) => Math.min(97, p + 4));
      }}
    >
      <img src={afterSrc} alt={altAfter} draggable={false} className="absolute inset-0 w-full h-full object-cover" />
      <img
        src={beforeSrc}
        alt={altBefore}
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />

      <span className="absolute top-4 left-4 rounded-full bg-[#060F1F]/70 backdrop-blur-sm px-4 py-1.5 font-tech text-[10px] font-semibold uppercase tracking-[0.2em] text-white">
        {beforeLabel}
      </span>
      <span className="absolute top-4 right-4 rounded-full bg-sky-600/85 backdrop-blur-sm px-4 py-1.5 font-tech text-[10px] font-semibold uppercase tracking-[0.2em] text-white">
        {afterLabel}
      </span>

      <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-white shadow-[0_0_12px_rgba(0,0,0,0.5)]" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-white shadow-2xl flex items-center justify-center text-sky-700 border-4 border-white/80">
          <MoveHorizontal className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};
